import { render } from "./notfoundView.vue?vue&type=template&id=4e5ccc45&scoped=true"
const script = {}

import "./notfoundView.vue?vue&type=style&index=0&id=4e5ccc45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5ccc45"]])

export default __exports__